import * as Sentry from '@sentry/react';

import { getSentryDsn, getSentryEnvironment } from './lib/runtimeConfig';

const sessionScanLocatorPattern = /(\/s\/v1\/|\/session-scans\/v1\/)[A-Za-z0-9_-]{43}/g;
const isSessionScanEntry =
  typeof window !== 'undefined' && /^\/s\/v1(?:\/|$)/.test(window.location.pathname);

export function redactSessionScanLocators<T>(value: T): T {
  if (typeof value === 'string') {
    return value.replace(sessionScanLocatorPattern, '$1[redacted]') as T;
  }

  if (Array.isArray(value)) {
    value.forEach((entry, index) => {
      value[index] = redactSessionScanLocators(entry);
    });
    return value;
  }

  if (value && typeof value === 'object') {
    Object.entries(value).forEach(([key, entry]) => {
      (value as Record<string, unknown>)[key] = redactSessionScanLocators(entry);
    });
  }

  return value;
}

const dsn = getSentryDsn()
  || 'https://e1ea0a099bd5a3ef57656a0c20a01b19@o4511775890800640.ingest.us.sentry.io/4511775914786816';

Sentry.init({
  dsn,
  environment: getSentryEnvironment(),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
      networkDetailDenyUrls: [/\/session-scans\/v1\/[A-Za-z0-9_-]{43}/],
      beforeAddRecordingEvent: redactSessionScanLocators,
    }),
  ],
  beforeBreadcrumb: redactSessionScanLocators,
  beforeSend: redactSessionScanLocators,
  beforeSendTransaction: redactSessionScanLocators,
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: isSessionScanEntry ? 0 : 1.0,
  replaysOnErrorSampleRate: isSessionScanEntry ? 0 : 1.0,
});
